<template>
	<footer>
		<div class="redes">
			<!-- <img src="../../assets/logo-sm.png" alt="Nacional Tickets"> -->
			<img src="@/assets/logo.svg" alt="Nacional Tickets">
			<a href="https://www.facebook.com/nacional" class="red-facebook"><facebook-icon></facebook-icon></a>
			<a href="https://twitter.com/nacional" class="red-twitter"><twitter-icon></twitter-icon></a>
			<a href="https://www.instagram.com/nacional/" class="red-instagram"><instagram-icon></instagram-icon></a>
			<a href="https://www.youtube.com/channel/UCN4JBah1YUV9Qd8iQmjNq3Q" class="red-youtube"><youtube-icon></youtube-icon></a>
		</div>
		<span>Copyright © {{ new Date().getFullYear() }} Club Nacional de Football. Powered by <a href="mailto:hola@prudenc.io?Subject=Contacto%20desde%20Nacional">Prudencio</a></span>
	</footer>
</template>

<script>
	import { FacebookIcon, TwitterIcon, InstagramIcon, YoutubeIcon } from 'vue-feather-icons'

	export default{
		components: {
			FacebookIcon,
			TwitterIcon,
			InstagramIcon,
			YoutubeIcon
		}
	}
</script>

<style scoped lang="scss">
	footer{
		width: 100%;
		height: 74px;
		margin: 0;
		padding: 0;
		padding: 0px 30px;
		@include flex(row, space-between, center);
		// margin-top: 30px;
		background: var(--color-white);
		border-top: 1px solid #f1f1f1;
		// background: url('../../assets/footer.png');
		// background-size: cover;
		// background-position: center center;
		// background-repeat: no-repeat;

		.redes{
			@include flex(row, flex-start, center);

			a{
				padding: 0;
				line-height: 1em;
				text-decoration: none;
				margin: 0 15px;

				svg{
					stroke-width: 1.5px;
					// color: var(--color-white);
					color: var(--color-blue-dark);
					width: 18px;
					height: 18px;
					cursor: pointer;
					transition: all 0.2s;
				}

				&:hover svg{
					opacity: 0.8;
				}

				// &.red-twitter:hover svg{
				// 	color: #1DA1F2;
				// 	fill: #1DA1F2;
				// }

				// &.red-facebook:hover svg{
				// 	color: #4267B2;
				// 	fill: #4267B2;
				// }

				// &.red-youtube:hover svg{
				// 	color: #FFFFFF;
				// 	fill: #FF0000;
				// }

				// &.red-instagram:hover svg{
				// }
			}

			img{
				// height: 57px;
				height: 34px;
				width: auto;
				margin: 0;
				margin-right: 12px;
			}
		}

		span{
			// font-size: 12px;
			// margin: 0;
			// font-weight: 600;
			// color: var(--color-white);

			font-family: var(--font-family-fira);
			font-size: 12px;
			font-weight: var(--font-weight-regular);
			-webkit-letter-spacing: 0;
			-moz-letter-spacing: 0;
			-ms-letter-spacing: 0;
			letter-spacing: 0;
			line-height: 19px;
			
			color: var(--color-blue-dark);

			a{
				-webkit-text-decoration: underline;
				text-decoration: underline;
				color: var(--color-blue-dark);
				transition: all .2s;

				&:hover{
					opacity: 0.8;
				}
			}
		}
	}

	@media screen and (max-width: 1308px){
		footer{
			padding-left: 24px;
			padding-right: 24px;
		}
	}

	@media screen and (max-width: 800px){
		footer{
			padding-top: 24px;
			padding-bottom: 24px;
			height: auto;
			@include flex(column, center, flex-start);

			.redes{
				margin-bottom: 6px;
			}

			span{
				margin-top: 6px;
			}
		}
		// footer span{
		// 	@include flex(column, center, center);
		// }
	}

	@media screen and (max-width: 530px){
		footer .redes{
			margin-bottom: 8px;
			
			a{
				margin: 0 8px;
			}

			img{
				height: 28px;
				margin-right: 8px;
			}
		}
	}
</style>
